import React, {Component} from 'react';
import {Table, Dimmer, Loader} from 'semantic-ui-react';

class LoadingRow extends Component {
  render() {
    return (
      <Table.Row>
        <Table.Cell colSpan={this.props.colSpan} style={{height:'10em', background:'transparent !important'}}>
          <Dimmer.Dimmable style={{background:'transparent !important'}}>
              <Dimmer active inverted style={{backgroundColor:'transparent !important' }}>
                <Loader inline='centered'>Cargando</Loader>
              </Dimmer>
          </Dimmer.Dimmable>
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default LoadingRow;



// WEBPACK FOOTER //
// ./src/components/extras/LoadingRow.js